import styled from "@emotion/styled";

interface SpacerContainerProps {
  height?: string;
  width?: string;
  minHeight?: string;
  minWidth?: string;
}

export const SpacerContainer = styled.div<SpacerContainerProps>`
  height: ${props => props.height};
  width: ${props => props.width};
  min-height: ${props => props.minHeight};
  min-width: ${props => props.minWidth};
`;
